import React from "react";
import { Button } from "semantic-ui-react";
import ReactTable, { ReactTableDefaults } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/pro-regular-svg-icons";
import { saveAs } from "file-saver";
import moment from "moment";

const SMSEvents = ({ report, t }) => {
  if (!Array.isArray(report.report_data) || report.report_data.length < 1) {
    return (
      <>
        <h3 className="report-heading">{t(report.report_name).message || report.report_name}</h3>
        <p className="no-data">{t("no_data").message || "No data"}</p>
      </>
    );
  }

  const data = report.report_data.map(d => JSON.parse(d));

  const exportData = async () => {
    let csv = "";
    let header = (t("location").message || "Location") + ", ";
    header += (t("wo_count").message || "WO Count") + ", ";
    header += (t("online_checkin_sms_sent_count").message || "Online check-in SMS sent count") + ", ";
    header += (t("online_checkin_sms_percentage").message || "Online check-in SMS percentage") + ", ";
    header += (t("online_checkin_sms_confirmation_count").message || "Online check-in SMS confirmation count") + ", ";
    header += (t("online_checkin_sms_confirmation_percentage").message || "Online check-in SMS confirmation percentage") + ", ";
    header += (t("keylocker_checkin_sms_sent_count").message || "Keylocker check-in SMS sent count") + ", ";
    header += (t("keylocker_checkin_sms_sent_percentage").message || "Keylocker check-in SMS sent percentage") + ", ";
    header += (t("diagnose_overview_sms_sent_count").message || "Diagnose overview SMS sent count") + ", ";
    header += (t("diagnose_overview_sms_sent_percentage").message || "Diagnose overview SMS sent percentage") + ", ";
    header += (t("diagnose_overview_sms_confirmation_count").message || "Diagnose overview SMS confirmation count") + ", ";
    header += (t("diagnose_overview_sms_confirmation_percentage").message || "Diagnose overview SMS confirmation percentage") + ", ";
    header += (t("repair_overview_sms_sent_count").message || "Repair overview SMS sent count") + ", ";
    header += (t("repair_overview_sms_sent_percentage").message || "Repair overview SMS sent percentage") + ", ";

    let values = data
      .map(
        d =>
          d.location +
          ", " +
          d.wo_count +
          ", " +
          d.online_checkin_sms_sent_count +
          ", " +
          d.online_checkin_sms_sent_percent +
          ", " +
          d.online_checkin_sms_confirmation_count +
          ", " +
          d.online_checkin_sms_confirmation_percent +
          ", " +
          d.keylocker_checkin_sms_sent_count +
          ", " +
          d.keylocker_checkin_sms_sent_percent +
          ", " +
          d.diagnose_overview_sms_sent_count +
          ", " +
          d.diagnose_overview_sms_sent_percent +
          ", " +
          d.diagnose_overview_sms_confirmation_count +
          ", " +
          d.diagnose_overview_sms_confirmation_percent +
          ", " +
          d.repair_overview_sms_sent_count +
          ", " +
          d.repair_overview_sms_sent_percent +
          ", "
      )
      .join("\n");

    csv += header + "\n" + values;
    saveAs(new File([csv], { type: "text/csv;charset=utf-8" }), "SMSEvents" + moment().format("YYYYMMDD") + ".csv");
  };

  const combineFields = (count, percent) => `${count} (${percent ? percent.toFixed(2) : 0.0}%)`;

  return (
    <>
      <h3 className="report-heading">
        {t(report.report_name).message || report.report_name}
        <Button color="green" floated="right" basic onClick={() => exportData()}>
          <span style={{ marginRight: "10px" }}>{t("export").message || "Export"}</span>
          <FontAwesomeIcon icon={faFileExport} />
        </Button>
      </h3>
      <div className="dealer-reports-table-container">
        <ReactTable
          className="ReactTable -floated-table no-overflow all-data-table -initial-margin"
          data={data}
          showPagination={false}
          showPageSizeOptions={false}
          sortable={false}
          style={{ maxHeight: "600px" }}
          resizable={false}
          defaultPageSize={data.length || 0}
          pageSize={data.length || 0}
          noDataText={
            <div className="Table__no-results">
              <p>{t("no_data").message || "No data"}</p>
            </div>
          }
          column={{
            ...ReactTableDefaults.column,
            headerClassName: "ReactTable__column-header dealer-table-header",
            className: "ReactTable__column",
          }}
          columns={[
            {
              Header: <strong>{t("location").message || "Location"}</strong>,
              accessor: "location",
            },
            {
              Header: <strong>{t("wo_count").message || "WO Count"}</strong>,
              accessor: "wo_count",
            },
            {
              Header: <strong>{t("online_checkin_sms_sent").message || "Online check-in SMS sent"}</strong>,
              id: "Online check-in SMS sent",
              accessor: d => combineFields(d.online_checkin_sms_sent_count, d.online_checkin_sms_sent_percent),
            },
            {
              Header: <strong>{t("online_checkin_sms_confirmation").message || "Online check-in SMS confirmation"}</strong>,
              id: "Online check-in SMS confirmation",
              accessor: d => combineFields(d.online_checkin_sms_confirmation_count, d.online_checkin_sms_confirmation_percent),
            },
            {
              Header: <strong>{t("keylocker_checkin_sms_sent").message || "Keylocker check-in SMS sent"}</strong>,
              id: "Keylocker check-in SMS sent",
              accessor: d => combineFields(d.keylocker_checkin_sms_sent_count, d.keylocker_checkin_sms_sent_percent),
            },
            {
              Header: <strong>{t("diagnose_overview_sms_sent").message || "Diagnose overview SMS sent"}</strong>,
              id: "Diagnose overview SMS sent",
              accessor: d => combineFields(d.diagnose_overview_sms_sent_count, d.diagnose_overview_sms_sent_percent),
            },
            {
              Header: <strong>{t("diagnose_overview_sms_confirmation").message || "Diagnose overview SMS confirmation"}</strong>,
              id: "Diagnose overview SMS confirmation",
              accessor: d => combineFields(d.diagnose_overview_sms_confirmation_count, d.diagnose_overview_sms_confirmation_percent),
            },
            {
              Header: <strong>{t("repair_overview_sms_sent").message || "Repair overview SMS sent"}</strong>,
              id: "Repair overview SMS sent",
              accessor: d => combineFields(d.repair_overview_sms_sent_count, d.repair_overview_sms_sent_percent),
            },
          ]}
        />
      </div>
    </>
  );
};

export { SMSEvents };
